module.exports = new __parcel__URL__("pulp-fiction.63e5e1a8.jpg").toString();